export default __webpack_public_path__ + "static/media/4.809ac6a0.svg";